import { render, staticRenderFns } from "./MFIHome.vue?vue&type=template&id=197e6704&scoped=true"
import script from "./MFIHome.vue?vue&type=script&lang=js"
export * from "./MFIHome.vue?vue&type=script&lang=js"
import style0 from "./MFIHome.vue?vue&type=style&index=0&id=197e6704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e6704",
  null
  
)

export default component.exports